import {
  callOnBeforeRun,
  ChatUiEventTypes,
  sendChatUiEvent,
} from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import {
  MinimalChat,
  type RunContextCallback,
} from '@trimble-agentic-internal-npm-local/agentic-chat-ui';
import { useCallback, useContext } from 'react';

import { EmbeddedConfigContext } from '../providers/embedded-config-provider';
import { mapDynamicToolsToRunContext } from '../utilities/toolUtils';
import './MinimalChatPage.css';

export const EmbeddedMinimalChat = () => {
  const context = useContext(EmbeddedConfigContext);

  const handleOnBeforeRun = useCallback(
    async (
      agentId: string
    ): Promise<Awaited<ReturnType<RunContextCallback>>> => {
      const dynamicRunContext = await callOnBeforeRun(
        agentId,
        context?.chatConfig.onBeforeRunTimeout
      );

      return mapDynamicToolsToRunContext(dynamicRunContext);
    },
    [context?.chatConfig.onBeforeRunTimeout]
  );

  return (
    <div className='h-[100dvh] w-[100dvw] flex flex-col items-center justify-center'>
      <MinimalChat
        agentId={context?.chatConfig.agentId || ''}
        threadId={context?.chatConfig.threadId}
        hideModelSelection={
          context?.chatConfig.uiConfig.chatInput.hideModelSelection
        }
        chatInputButtons={context?.chatConfig.uiConfig.chatInput.buttons}
        onBeforeRunCall={handleOnBeforeRun}
        onChatInputButtonClick={buttonId => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnChatInputButtonClick,
            payload: buttonId,
          });
        }}
        disabled={false}
      />
    </div>
  );
};
